export default __webpack_public_path__ + "static/0164-9e4c7ecd7351b1ccd1679250f3c0d9c3.png";